<div class="row main-container">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" style="padding-top: 10px; padding-bottom: 40px;">
        <div class="panel panel-default content">
            <div class="panel-heading">
                <i class="fa fa-{{icon}}" aria-hidden="true"></i>{{title}}
            </div>
            <div class="panel-body">
                <ng-content></ng-content>
            </div>
        </div>
    </div>
</div>